module.exports = __webpack_public_path__ + "assets/cf03ad7aee8d26a6ef249271cbcae34b.png";